<template>
  <div class="body">
    <el-dialog title="" :visible.sync="showConfirm" width="71%" :before-close="handleClose" center>
      <div class="margin fontStyle">
        公告开始时间已过期，系统已为您更新时间为:
      </div>
      <div class="margin tableStyle">
        <el-table :data="tableData" border >
          <el-table-column prop="title" label="" width="126" align="center" header-align="center">
          </el-table-column>
          <el-table-column label="公告时间" width="250" align="center" header-align="center">
            <template slot-scope="scope">
              <span>{{scope.row.noticeStartTime}} 至 {{scope.row.noticeEndTime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="signEndTime" label="报名截止时间" width="200" align="center" header-align="center"></el-table-column>
          <el-table-column label="自由报价期" width="250" align="center" header-align="center">
            <template slot-scope="scope">
              <span>{{scope.row.quoteStartTime}} 至 {{scope.row.quoteEndTime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="limitQuoteStartTime" label="限时报价开始时间" width="200" align="center" header-align="center"></el-table-column>
        </el-table>
      </div>
      <div class="fontStyle">
        更新时间并确认公告请点击“确定更新”按钮，不更新时间可以点击“取消”按钮后驳回公告。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取 消</el-button>
        <el-button type="primary" @click="Confirm">确定更新</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'updateConfirmInfo',
  components: {

  },
  props: {
    updateConfirmData: {
      type: Object,
      default() {
        return {};
      }
    },
    showConfirm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableData: []
    };
  },
  computed: {
  },
  watch: {
    showConfirm(n) {
      if (n) {
        // console.log(this.updateConfirmData);
        this.tableData[0] = this.updateConfirmData.oldNoticeStartTimeResForm;
        this.tableData[0].title = '原公告信息';
        this.tableData[1] = this.updateConfirmData.newNoticeStartTimeResForm;
        this.tableData[1].title = '更新后公告信息';
      }
    }
  },
  methods: {
    Confirm() {
      this.$emit('confirm');
    },
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped lang="scss">
.body {
  .margin {
    margin-bottom: 20px;
  }
  .fontStyle {
    font-weight: 500;
  }
  .tableStyle /deep/ tr:nth-last-of-type(1) td {
    color: red;
  }
}
</style>
